// Mirrors Tp_Communication.Constant.OfficeGroupConstants — keep in sync. The id is fixed by the CD-5311 ad-hoc
// script that seeds the "EU Offices" office group (Belgium, Hungary, Spain).
const OfficeGroupEnum = {
  Europe: 1,
};

export default OfficeGroupEnum;
